<div *ngIf="data" class="close">
  <mat-icon (click)="close()">close</mat-icon>
</div>
<h3 *ngIf="data" class="row col-sm-12 warning">
  {{ data.message }}<br />
  <small *ngIf="data">preencha o formulário abaixo</small>
</h3>

<div class="content">
  <div class="col-left">
    <mat-action-list>
      <h3 matSubheader>Meu histórico</h3>
      <ng-container *ngFor="let experience of experiences$ | async">
        <button mat-list-item (click)="editProfessionalExperience(experience)"
          [ngClass]="{ selected: experience.id == formVacancy.get('id').value }">
          <h3 matLine>{{ experience.organization }}</h3>
          <p matLine>
            <span>de {{ experience.init_date | date : "dd/MM/yyyy" }} até
              {{
              (experience.final_date | date : "dd/MM/yyyy") || "o momento"
              }}</span>
          </p>
          <button type="button" mat-icon-button color="warn" (click)="removeExperience($event, experience)">
            <mat-icon>remove</mat-icon>
          </button>
        </button>
      </ng-container>
      <ng-container *ngIf="(experiences$ | async)?.length === 0">
        <button
          mat-list-item style="
          background: #f3f2f2;
      ">
          <h3 matLine>Nenhuma experiência encontrada</h3>
        </button>
      </ng-container>
    </mat-action-list>
  </div>

  <div class="col-right">
    <form [formGroup]="form" (submit)="submitDesiredJobTitle()" id="desiredJobTitle">
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Cargo desejado</mat-label>
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let job of form.get('desiredJobTitles').value" [removable]="true"
              (removed)="removeDesiredJob(job)">
              {{ job }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <input id="desiredJobTitle" *ngIf="form.get('desiredJobTitles').value.length < 3" type="text"
            placeholder="Nome do cargo desejado" matInput formControlName="desiredJobTitle"
            (blur)="onBlurInput2('desiredJobTitle')"
            (keyup)="filteredDesirableJobs = _filterDesirableJobs($event.target.value)" [matAutocomplete]="auto"
            [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addDesiredJob($event)" #desiredJobTitleInput />
          <mat-autocomplete #auto (optionSelected)="onOptionSelected($event)">
            <mat-option *ngFor="let desirableJob of filteredDesirableJobs" [value]="desirableJob.Name">
              {{ desirableJob.Name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="
              form.get('desiredJobTitle').hasError('invalid') &&
              form.get('desiredJobTitle').touched
            ">
            Valor inválido. Escolha uma opção válida.
          </mat-error>
          <mat-hint *ngIf="form.get('desiredJobTitles').value.length === 3">
            3 cargos selecionados, limite máximo atingido.
          </mat-hint>
          <mat-error *ngIf="form.get('desiredJobTitle').errors?.required">
            Cargo desejado é obrigatório
          </mat-error>
        </mat-form-field>

        <div class="actions">
          <button type="submit" class="custom-primary" mat-raised-button style="margin: 2px; height: 53px"
            [disabled]="!form.valid">
            Salvar
          </button>
        </div>
      </div>

      <div class="row" style="margin-bottom: 10px">
        <mat-slide-toggle color="primary" formControlName="isPcd">Usar vaga PCD</mat-slide-toggle>
      </div>

      <div class="row" *ngIf="form.get('isPcd').value">
        <mat-form-field appearance="outline">
          <mat-label>Qual a sua deficiência</mat-label>
          <mat-select formControlName="pcdDescription" placeholder="Escolha uma deficiência">
            <ng-container *ngFor="let pcd of pcdList">
              <mat-optgroup *ngIf="pcd.group; else pcdListDefault" [label]="pcd.group">
                <ng-container *ngFor="let pcdDesc of pcd.list">
                  <mat-option [value]="pcd.group + ' - ' + pcdDesc.name">
                    <span style="margin-right: 10px" *ngIf="
                        form.get('pcdDescription').value ===
                        pcd.group + ' - ' + pcdDesc.name
                      ">
                      <small>{{ pcd.group }} - </small>
                    </span>
                    <span>{{ pcdDesc.name }}</span>
                  </mat-option>
                </ng-container>
              </mat-optgroup>
              <ng-template #pcdListDefault>
                <mat-option [value]="pcd.default">{{ pcd.default }}</mat-option>
              </ng-template>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </form>

    <mat-divider></mat-divider>

    <div class="controls" style="margin-top: 20px">
      <button mat-stroked-button color="primary" (click)="editable(true)" *ngIf="editMode === false">
        <mat-icon>add</mat-icon>
        Inserir experiência
      </button>

      <button mat-stroked-button color="warn" (click)="editable(false)" [disabled]="submiting"
        *ngIf="editMode === true">
        <mat-icon>close</mat-icon>
        Cancelar
      </button>
    </div>

    <ng-container *ngIf="editMode">
      <form style="margin-top: 20px" [formGroup]="formVacancy" (submit)="submitExperience()">
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Empresa</mat-label>
            <input matInput type="text" placeholder="Nome da empresa" formControlName="company" />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Cargo</mat-label>
            <input type="text" id="Sinonimo" (blur)="onBlurInput('sinonimo')" (focus)="onFocusInput('sinonimo')"
              placeholder="Cargo" (keyup)="_filterSinonimo($event.target.value)" matInput formControlName="sinonimo"
              [matAutocomplete]="autoSinonimo" />
            <mat-autocomplete #autoSinonimo="matAutocomplete">
              <mat-option *ngFor="let Sinonimo of filteredSinonimo" [value]="Sinonimo.Name" [title]="Sinonimo.Name">
                {{ Sinonimo.Name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="formVacancy.get('sinonimo').errors?.invalid">Escolha um dos valores que aparecem na lista
              ao
              digitar</mat-error>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Descrição do seu trabalho</mat-label>
            <textarea matInput placeholder="Descrição do seu trabalho" formControlName="description"
              style="max-height: 150px; min-height: 150px"></textarea>
            <mat-hint>Informe até 1000 caracteres</mat-hint>
          </mat-form-field>
        </div>

        <div class="row" style="margin-top: 10px">
          <mat-label style="margin-left: 10px; margin-right: 5px">Regime de Contratação:</mat-label>
          <mat-radio-group formControlName="workregime">
            <mat-radio-button value="CLT" style="margin-right: 10px">
              CLT
            </mat-radio-button>
            <mat-radio-button value="PJ" style="margin-right: 10px">
              PJ
            </mat-radio-button>
            <mat-radio-button value="Informal"> Informal </mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="formVacancy.get('workregime').errors?.invalid">Escolha uma das opções</mat-error>
        </div>

        <div class="row" style="margin-top: 10px">
          <mat-form-field appearance="outline">
            <mat-label>Modelo de trabalho</mat-label>
            <mat-select placeholder="Selecione uma opção" formControlName="modalityjob">
              <mat-option value="Presencial">Presencial</mat-option>
              <mat-option value="Home Office">Home Office</mat-option>
              <mat-option value="Híbrido">Híbrido</mat-option>
            </mat-select>
            <mat-error *ngIf="formVacancy.get('modalityjob').errors?.invalid">Escolha uma das opções</mat-error>
            <mat-error *ngIf="formVacancy.get('modalityjob').errors?.required">Por favor selecione uma opção</mat-error>
          </mat-form-field>
        </div>

        <div class="row" style="margin-bottom: 20px; margin-top: 20px">
          <mat-slide-toggle color="primary" formControlName="currentJob">Estou atualmente nesse
            emprego</mat-slide-toggle>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Data de admissão</mat-label>
            <!-- <input matInput placeholder="Data de admissão" formControlName="admissionDate" type="text"
                            mask="00/00/0000" inputmode="numeric"/> -->
            <input matInput placeholder="MM/AAAA" formControlName="admissionDate" type="text" mask="00/0000"
              inputmode="numeric" />
            <mat-error *ngIf="
                formVacancy.get('admissionDate').errors?.invalidDate === true
              ">Informe uma data valida</mat-error>
            <mat-error *ngIf="
                formVacancy.get('admissionDate').errors?.beforeDate === true
              ">Data não pode ser maior que a data de admissão</mat-error>
          </mat-form-field>
        </div>

        <ng-container *ngIf="formVacancy.get('currentJob').value === false">
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Data de saída</mat-label>
              <!-- <input matInput type="text" placeholder="Data de saída" formControlName="departureDate"
                                mask="00/00/0000" inputmode="numeric"/> -->
              <input matInput type="text" placeholder="MM/AAAA" formControlName="departureDate" mask="00/0000"
                inputmode="numeric" />
              <mat-error *ngIf="
                  formVacancy.get('departureDate').errors?.departure === true
                ">Informe a data de saída desse emprego</mat-error>
              <mat-error *ngIf="
                  formVacancy.get('departureDate').errors?.invalidDate === true
                ">Informe uma data valida</mat-error>
              <mat-error *ngIf="
                  formVacancy.get('departureDate').errors?.maxDate === true
                ">Data não pode ser maior que a atual</mat-error>
            </mat-form-field>
          </div>
        </ng-container>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Último salário</mat-label>
            <input matInput type="text" placeholder="Seu último salário" currencyMask inputmode="numeric"
              formControlName="salary" />
          </mat-form-field>
        </div>

        <div class="actions">
          <button type="submit" class="custom-primary" mat-raised-button [disabled]="submiting">
            Salvar
          </button>
        </div>
      </form>
    </ng-container>

    <!-- <ng-container *ngIf="(experiences$ | async)?.length === 0">
      <app-empty-content
        text='Clique em "Nova experiência" para adicionar um cargo'
      ></app-empty-content>
    </ng-container> -->
    <!-- 
        <ng-template #emptyContent>
            <app-empty-content text='Clique em "Nova experiência" para adicionar um cargo'></app-empty-content>
        </ng-template> -->
  </div>
</div>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>

